import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {deleteCalendarChildView as deleteCalendarChildViewAPI} from '../../../services/calendarViews'

export async function deleteCalendarChildView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await deleteCalendarChildViewAPI(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Delete Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
